import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-detail-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-detail-skeleton.html',
  styleUrl: './product-detail-skeleton.scss'
})
export class ProductDetailSkeleton {}

